import apiClient from "../api";

export const getSuppliersData = async (storeId) => {
    try {
        const response = await apiClient.get(`gestock/suppliers/${storeId}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};
